const { gql } = require('@apollo/client');

export const GET_HEADER_CONTENT = gql`
  query GetHeader {
    header {
      data {
        attributes {
          city
          street
          house
          phone_1
          phone_2
          vk_link
        }
      }
    }
  }
`;
